import { Typography } from '@breetometer/components';
import { TrashIcon } from 'BreetAssets';
import { Prompt } from 'BreetComponents';
import { capitalizeFirstLetter, handleApiError } from 'BreetHelpers';
import { closeModal, selectModals, useAppDispatch, useAppSelector, useDeleteWalletAddressMutation } from 'BreetRedux';
import { useCallback } from 'react';

export const DialogDeleteWalletAddress = () => {
	const [deleteWalletAddress, { isLoading }] = useDeleteWalletAddressMutation();

	const dispatch = useAppDispatch();

	const modals = useAppSelector(selectModals);

	const modal = modals.find((modalItem) => modalItem.id === 'deleteWalletAddress');

	const walletAddressData = modal?.metadata as { id: string; address: string; label: string } | undefined;

	const closeDeleteModal = useCallback(() => {
		dispatch(closeModal('deleteWalletAddress'));
	}, [dispatch]);

	const deleteBeneficiary = useCallback(() => {
		if (!walletAddressData) {
			console.warn('Wallet address data is missing');
			return;
		}
		deleteWalletAddress({ walletId: walletAddressData.id }).unwrap().then(closeDeleteModal).catch(handleApiError);
	}, [walletAddressData, deleteWalletAddress, closeDeleteModal]);

	const title = 'Delete Wallet Address';

	const description = 'Are you sure you want to delete this wallet address?';

	return (
		<Prompt
			title={title}
			description={description}
			content={
				<div>
					<label
						htmlFor='walletAddress'
						className='color-primary-100'
					>
						{capitalizeFirstLetter(walletAddressData?.label)}
					</label>
					<Typography className='font-sm selected'>{walletAddressData?.address}</Typography>
				</div>
			}
			cancelBtnText='Cancel'
			icon={
				<TrashIcon
					variant='secondary-outline'
					className='svg-dark svg-dark-outline svg-dark-fill'
				/>
			}
			isLoading={isLoading}
			onCancel={closeDeleteModal}
			onProceed={deleteBeneficiary}
			proceedBtnText='Delete'
		/>
	);
};
